export const cardLockAndReplace = {
    showFees: true,
};
